// Dependencies
import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';
import $ from 'jquery';
import { CircularProgress } from 'material-ui';

const ProfileLink = createClass({

  propTypes: {
    imageUrl: PropTypes.string,
    companySlugName: PropTypes.string,
    largeImage: PropTypes.bool,
    email: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
    innerStyle: PropTypes.object,
    isLoading: PropTypes.bool,
    alwaysGrey: PropTypes.bool
  },

  getInitialState() {
    const colors = [
      'is-red',
      'is-pink',
      'is-purple',
      'is-deep-purple',
      'is-indigo',
      'is-blue',
      'is-light-blue',
      'is-cyan',
      'is-teal',
      'is-green',
      'is-deep-orange',
    ];

    const assignRandomColorClass = () => {
      return colors[Math.floor(Math.random() * colors.length)];
    };

    const colorClass = `profile-image-letter ${this.props.alwaysGrey ? 'is-grey' : assignRandomColorClass()}`;

    return { colorClass };
  },

  componentDidMount() {
    const resizeCss = (wrapper) => {
      let margin;
      if (this.width > this.height) {
        wrapper.css({ width: '100%', height: 'auto' });
        margin = (128 - this.height) / 2;
        wrapper.css({ 'margin-top': margin, 'margin-bottom': margin });
      } else {
        wrapper.css({ width: 'auto', height: '100%' });
        margin = (128 - this.width) / 2;
        wrapper.css({ 'margin-left': margin, 'margin-right': margin });
      }
    };
    if (this.props.imageUrl && this.props.largeImage) {
      $('#largeImage').load(() => {
        resizeCss.call(this, $('#largeImage'));
      });
    }
  },

  render() {
    const slugOrEmail = this.props.companySlugName || this.props.email;
    const classes = getClassNames('profile-image', this.props.className);
    let image;
    if (this.props.imageUrl) {
      if (this.props.largeImage) {
        image = <img id="largeImage" className="profile-image-image" src={this.props.imageUrl} />;
      } else {
        image = <img className="profile-image-image" src={this.props.imageUrl} />;
      }
    } else if (slugOrEmail) {
      const companyLetter = slugOrEmail.charAt(0).toUpperCase();
      image = <div className={this.state.colorClass} style={this.props.innerStyle} >{companyLetter}</div>;
    }

    /* jshint ignore:start */
    return (
      this.props.isLoading ?
      <CircularProgress size={20}/> :
      <div className={classes} style={this.props.style} onClick={this.props.onClick}>
        {image}
      </div>
    );
    /* jshint ignore:end */
  },
});

export default ProfileLink;



// WEBPACK FOOTER //
// ./src/app/components/app-bar/profile-image.jsx